import { BasePageProps, BasePageState, basePageInitialState } from '../BasePage'


import { store } from '../../redux/store'

import { createReducer, createAction } from '@reduxjs/toolkit'

export interface PetPageProps extends BasePageProps{}

type PetState = {
    tipo_animali: string | undefined
    nome: string | undefined
    razza: string | undefined
    chip: boolean | undefined
    tipo_animaliError: string | undefined
    nomeError: string | undefined
    razzaError: string | undefined
    chipError: string | undefined

    tipi: any
}

export type PetPageState = PetState & BasePageState

export const petPageInitialState : PetPageState = {
    ...basePageInitialState,
    ...{
        tipo_animali: undefined,
        nome: undefined,
        razza: undefined,
        chip: undefined,
        tipo_animaliError: undefined,
        nomeError: undefined,
        razzaError: undefined,
        chipError: undefined,
        tipi: undefined,
    }
}

export const petsUpdate = createAction<PetPageState>('pets/update')

export const petReducer = createReducer ( 
    petPageInitialState,
    (builder) => {
        builder.addCase(petsUpdate, (state, action) => {
            return action.payload as PetPageState
        })
    }
)

export type PetsRootState = ReturnType<typeof store.getState>
export type PetsDispatch = typeof store.dispatch